import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export default function render(_ctx, _cache) {
  return (_openBlock(), _createBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, [
    _createVNode("path", { d: "M14.049 5.54a1 1 0 011.071.443l.994 1.587a1 1 0 00.316.316l1.587.994a1 1 0 01.444 1.072l-.42 1.824a1 1 0 000 .448l.42 1.825a1 1 0 01-.444 1.07l-1.587.995c-.128.08-.236.188-.316.316l-.994 1.587a1 1 0 01-1.071.444l-1.825-.42a1 1 0 00-.447 0l-1.825.42a1 1 0 01-1.071-.444l-.994-1.587a1.001 1.001 0 00-.317-.316l-1.586-.994a1 1 0 01-.444-1.071l.419-1.825a1 1 0 000-.448l-.42-1.824a1 1 0 01.445-1.072l1.586-.994a1 1 0 00.317-.316l.994-1.587a1 1 0 011.07-.443l1.825.419a1 1 0 00.448 0l1.825-.42z" }),
    _createVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M9.515 12.536l2.035 1.949 2.935-4.97"
    })
  ]))
}